<template>
    <div>
        <div v-show="!showKeywords" id="mainContent" class="modal-container has-text-centered" style="overflow-Y: auto;" :style="{'max-height': mHeight}"> <!--  'border-radius' : borderRadius,  -->
            <div v-if="dupAlert" class="dupAlert">
                
               <div class="top80">
                    <b>This url already exists as a miimu in your account. Save anyway?</b><br><br>
                    <button class="button is-small is-coolGreen" @click="saveCard(true)">YES</button>&nbsp;<button class="button is-small" @click="cancel">NO</button>
               </div>
               <br>
               <b>The following bundles contain a miimu with this url:</b>
               <br>
               <div v-for="i in dupRes[0]" :key="i.id" class="top5">
                   <div class="is-inline-block has-background-black" style="padding-right: 5px; border-top-left-radius: 8px"><div class="is-inline-block has-text-coolGreen handCursor fourDots">&nbsp;<b>::</b></div><span class="is-size-6 has-text-white"><b> {{i.rootName}}</b></span></div>
                   <i v-if="i.rootId != i.parentId" class="fa fa-arrow-right left3 right5"></i>
                   <div v-if="i.rootId != i.parentId" class="is-inline-block">
                       <div class="is-inline-block has-background-grey subBundleLabel"> <div class="is-inline-block "><div class="is-inline-block has-text-coolGreen handCursor fourDots">&nbsp;<b>::</b></div><span class=""><b> {{i.parentName}}</b></span> </div></div>
                   </div> 
               </div>
            </div>
            <div id="editWindowContent">
                
                <div class=""> 
                    <div class="top20 has-text-centered">
                        <button id="saveCarButt2" class="button is-small is-coolGreen" style="position: absolute; left: 20px; top: 24px" :disabled="!bundlesLoaded"  @click="saveCard">SAVE</button>
                        
                        <div id="saving" class="is-inline-block scaleHalf"></div>
                        <div class="is-inline-block" :class="{left60: $route.path == '/extension' && !$route.query.inApp}"><img src="@/assets/img/fourDotsLogo.png" width="18"/><b class="is-size-4"> {{mainTitle}}</b></div><!-- <span class="is-size-7">{{$root.app.version}}</span> -->
                        <span v-show="az.noSlash($route.path) != '/extension' || $root.app.inApp"><i id="xButt" class="delete top8 right5  handCursor"  @click="cancel"></i></span>
                        <!-- <button v-if="$route.path == '/extension' && !$route.query.inApp" class="button is-coolGreen is-small top5 right30 is-pulled-right" @click="$root.app.closeModal"><i class="fa fa-search"></i></button> -->
                        <button v-if="$route.path == '/extension' && !$route.query.inApp" class="button is-coolGreen is-small top5 right13 is-pulled-right" @click="$root.app.doLogout"><i class="fas fa-sign-out-alt"></i></button>
                    </div>
                </div>
        
                <div class="top13">
                    <div v-if="!myCard && !copyCard" class="columns top-20">
                        <div class="column has-text-right has-text-dark">
                            <div class="right10 has-text-white">
                                This card was contributed by another member of this collaboration. You may only assign it to a bundle within the collaboration. If you would like to assign it to one of your own bundles, <button class="button is-coolGreen is-small top2 xs" @click="makeACopy">Make a Copy</button>
                            </div>
                        </div>
                    </div>

                    <div v-show="waitAlert" class="bottom20">
                        Please wait for your bundle tree to load before saving.
                    </div>
                    
                    <div class="columns" style="max-width: 800px; margin: 0 auto" :class="{'top-20' : !myCard && !copyCard}"> 
                        <div class="column top5 bottom20">
                            <link-prevue style="height: 424px" ref="lp" class="is-inline-block" :url="url" :callApi="callApi" :cardPack="cardPack" :cardsIndex="cardsIndex" @close="$emit('close')"></link-prevue>
                        </div>
                       
                        <div class="column top5 bottom20 has-text-left">
                            <!-- TABS --> 
                            <div style="max-width: 380px; margin: 0  auto">
                                <div class="top-24 left10">
                                    <div class="azTab" :class="{selected: tabView == 1}"  @click="tabSwitcher(1)">locations</div>
                                    <div v-show="collabIdFromUrlCard || parentPublic" class="azTab" :class="{selected: tabView == 2}"  @click="tabSwitcher(2)">comments</div>
                                    <div id="v-step-5" class="azTab" :class="{selected: tabView == 3}"  @click="tabSwitcher(3)">notes</div>
                                    <div id="v-step-6" class="azTab" :class="{selected: tabView == 4}"  @click="tabSwitcher(4)">tags</div>
                                </div>
                            </div>
    
                            <div class="editWindowRightPanel" id="editWindowRightPanel">
                                <!-- Tree -->
                                <div v-show="tabView == 1" class="roundedCorners2 marginAutod editWindowTreeContainer" id="editWindowTreeContainer">
                                    <div class="has-background-dark">&nbsp;<span class="is-inline-block top2"><b>&nbsp;save into:</b>&nbsp;</span>&nbsp;<span v-show="myCard || copyCard" id="v-step-2" class="tinyPlusButt has-background-coolGreen" @click="addRootBundle">&nbsp;<b>+</b>&nbsp;</span> 
                                    <input @change="bundleFilter" type="text" class="is-pulled-right azTextInput right1 " style="width: 100px" v-model="bundleSearchTerm"/>
                                    <i class="is-pulled-right top3 right5 has-text-light is-size-7">filter:</i></div>
                                    <div class="treeView has-background-dark" id="treeView">
                                        <tree id="adsasdf" v-for="(item, index) in filteredTreeNoInbox" ref="cBoxes"
                                                :key="index" 
                                                :listName="item.listName" 
                                                :children="item.children" 
                                                :depth="0" 
                                                :id="item.id" 
                                                :aliasTgtId="item.aliasTgtId" 
                                                :currCardId="currCardId" 
                                                :selectedFromCopyCard="item.selectedFromCopyCard" 
                                                :hideMe="item.hideMe"
                                                :editWindow="thisRef"
                                                :collabId="item.collabId"
                                                >
                                        </tree>
                                        <br>
                                    </div>
                                </div>
        
                                <!-- COMMENTS -->
                                <div ref="commentsComp" id="commentsContainer" v-show="tabView == 2" class="editWindowCommentsDiv">
                                    <comments  class="posRelative" :obj="{item: computedItem, bundleId: bundleId, collabId: collabIdFromUrlCard, calledFromEdit: true, selectPublic: selectPublic}"></comments>
                                </div>
                                
                                
                                <div  v-show="tabView == 3" >
                                   
                                   
                                    <div class="tagNotesFlex">

    
                                         <!-- Notes -->
                                       
                                            <div id="tagNotesContainer" class="tagNotesItem roundedCorners2 has-background-dark" style="max-width: 398px;">
                                                <div class="top10 has-text-left left3 is-size-65">&nbsp;notes:</div>
                                               <!--  <div ref="note" class="editCardNotes" contenteditable="true" v-text="note"></div> -->
                        
                                                <div class="posRelative">
                                                    <div ref="note" @click="pbPlaceholderFocus"  @blur="checkPlaceholders" class="editCardNotes contentEditable" contenteditable="true"  v-html="note" v-linkified></div>
                                                    <div  v-show="pbPlaceholder" class="notesLabelPlaceholder pointerEventsOff">type general notes here</div>
                                                </div>
                        
                                                <div v-if="myCard" class="privNoteContainer" >
                                                    <div @click="openPrivNotes" class="handCursor is-inline "><i class="fa fa-caret-right has-text-coolGreen" v-show="!showPrivate"></i><i class="fa fa-caret-down has-text-coolGreen" v-show="showPrivate"></i>&nbsp;<span class="is-size-7 has-text-grey" style="position: relative; top: -2px;"><b>Private: (click to see)</b> </span></div>
                                                    <div v-show="showPrivate" class="top-5">
                                                        <div  ref="privNote" @focus="pvPlaceholderFocus" @blur="checkPlaceholders"  class="editCardNotesPriv contentEditable" contenteditable="true" v-html="privNote" v-linkified></div>
                                                        <div v-show="pvPlaceholder" class="notesLabelPlaceholder pointerEventsOff pvPlaceHolder top-5">type private notes here</div>
                                                    </div>
                                                   <!--  <div ref="note" class="editCardNotes" contenteditable="true" v-text="privNote"></div> -->
                                                </div>
                                            </div>
                                      
                                    </div>



                                </div>
                                <!-- Tags -->
                                <div  v-show="tabView == 4" >
                                    <div id="tagsContainer" class="tagNotesItem"  style="max-width: 398px; ">
                                            <div class="tagsView roundedCorners2">
                                                <div class="top10 has-text-left left3 is-size-65 ">&nbsp;tags:</div>
                                                <tags-input element-id="tags" class="top-10" ref="taginput" id="taginput"
                                                        v-model="processedTags"
                                                        :existing-tags="$root.app.tagUniverse"
                                                        :typeahead="true"
                                                        :typeahead-hide-discard="false"
                                                        :typeahead-show-on-focus="false"
                                                        >
                                                </tags-input>
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
               
                <div class="has-text-centered has-text-white has-background-dark is-italic">
                    <span v-show="!showUrl" class="handCursor" @click="showUrl = true">show url</span>
                    &nbsp;<span v-show="showUrl">{{this.dispUrl}}</span>&nbsp;
                </div>
        
                <div v-show="!$route.query.inApp" class=""> 
                    
                    <button id="saveCardButt" class="button wideButton is-small top10 is-coolGreen" :disabled="!bundlesLoaded" @click="saveCard" >SAVE</button>&nbsp;
                    <div class="cancelBtn is-small top10 handCursor"  @click="cancel">Cancel</div>

                </div>
                    <div v-if="caller && caller.doDel" class="cancelButton has-text-grey top10" @click="startDelete">Delete</div>
                    <br>
                <div v-show="!$route.query.inApp" class=""> 
                    <span class="is-pulled-left left10 handCursor" v-show="az.noSlash($route.path) == '/extension' && !$route.query.inApp" @click="openChromeTabsModal">IMPORT BROWSER TABS</span>
                    <div v-if="$root.app.showAds && $root.app.isAuth" class="is-pulled-right bottom20 right20 " @click="showKeywords = true">
                       
                        <div v-if="!adSure && !adCreated && $root.app.userAttrs['custom:is_admin'] == 1" class="handCursor">CREATE AD</div>
                       <!--  <div v-if="adSure && !adCrated">
                            Sure? <button class="button is-small is-coolGreen" @click="createAd">Y</button>&nbsp;<button class="button is-small" @click="adSureFalse">N</button>
                        </div> -->
                        <div v-if="adCreated"><i class="fa fa-check-circle has-text-coolGreen"></i> AD HAS BEEN CREATED</div>
                    </div>

                    <div v-if="collabIdFromUrlCard" class="top20 contributor">
                        <div class="has-text-grey-light is-pulled-left left10 bottom10 top-10" >Contributed by: <b>{{!myCard ? contributor : 'me'}}</b></div>   
                    </div>
                    <div class="delete clearTagResults" id="clearTagsAuto" @click="tester($event)"></div>    
                                
                    <!-- <div v-show="!callApi" class="pulledRightMargin top10">
                        <button v-show="!sure" class="button is-small " @click="sure = true">DELETE</button>
                        <span v-show="sure" class="has-text-dark is-size-7"><b>Sure?</b>&nbsp;<button id="yesButt" class="button is-coolGreen is-small" @click="deleteCard">YES</button> <button class="button is-small" @click="sure = false">NO</button></span>
                    </div> -->
                     <div>&nbsp;</div>
                </div>
                 <div v-show="$route.query.inApp" class="top40">&nbsp;</div>
            </div>
    
            <div v-if="showNewModal" class="modalContainerEditWindow">
                <modal-new-sub ref="mns" @close="closeNewSub" :callBack="callback" :collabId="collabId" :sub="sub"></modal-new-sub>
            </div>

            <div v-if="showCORSAlert" class="modalContainerEditWindow">
                <cors-alert ref="corsal" @close="closeCORS" :message="'The site from which you copied this image restricts this action. Try downloading it first and using the downloaded version. You can also use a screenshot of the image.'" ></cors-alert>
            </div>



            <div v-if="showChromeTabsModal" class="has-text-centered">
                <div id="chromeTabsInter">
                    <br>
                    <img src="@/assets/img/fourDotsLogo.png" width="12"/> <b> IMPORT BROWSER WINDOW TABS</b><br>
                    <div class="top20"><b>Name the bundle to put them into:</b></div>
                    <input  type="text" class=" azTextInput top5 is-size-6" style="width: 220px" v-model="chromeBundleName"/>
                    <br> 
                    <div class="top20"><b>Select Tabs to Import</b></div>
                   <div id="chromeTabsContainer">
                        <div v-for="(item, i) in tabsArray" :key="i" class="has-text-left chromeTabTitle">
                            <input type="checkbox" checked  :id="'cTab' + i" :value="item" v-model="checkedTabs"><span class="left10 ">{{item.title}}</span>
                        </div>
                   </div>
                    <br>
                    <button id="chromeTabsButt" class="button is-coolGreen is-small" @click="sendTabsToBackend">CREATE</button>&nbsp;<button class="button is-small" @click="closeChromeTabsModal">Cancel</button>
                </div>
            </div>
    
            <div v-if="showCheckMark">
                <div class="checkMarkDiv">
                    <div class="checkMarkDone">
                        <i class="fa fa-check fa-8x has-text-coolGreen"></i>
                    </div>
                </div>
            </div>
        </div>


        <div v-show="showKeywords" class="adKeywords has-text-centered">
            <div class="bottom10">Please provide some keywords:</div>

            <input type="text" class="text" v-model="k0" />
            <input type="text" class="text" v-model="k1" />
            <input type="text" class="text" v-model="k2" />
            <input type="text" class="text" v-model="k3" />
            <input type="text" class="text" v-model="k4" />

            <div  class="top20">
               
                <button  class="button wideButton is-small top10 is-coolGreen" @click="createAd">Create Ad</button>&nbsp;
                <div class="cancelBtn is-small top10 handCursor has-text-light"  @click="showKeywords = false">Cancel</div>
            </div>
        </div>

       

     
    </div>
</template>

<script>

import LinkPrevue from './LinkPrevue.vue' 
import Tree from '../components/Tree.vue'
import Comments from '../components/Comments.vue'
import VoerroTagsInput from '@voerro/vue-tagsinput'
import { AZEventBus } from '../components/AZEventBus'
import ModalNewSub from '../components/ModalNewSub'
import CorsAlert from '../components/ModalOK'
import bFactory from '../shared/bundleFactory.js'



export default{
    name: 'EditModal',
    components: {LinkPrevue, Tree, "tags-input": VoerroTagsInput, ModalNewSub, Comments, CorsAlert},
    props: {
        url: String, 
        callApi: {
            type: Boolean,
            default: true
        },
        cardsIndex: Number,
        caller: Object,
        bundleId: Number,
        cardPack: {
            type: Object,
            default: undefined
        },
        copyCard: {
            type: Boolean,
            default: false
        },
        before: {
            type: Number,
            default: null
        },
        after: {
            type: Number,
            default: null
        },
        fromBundleId: Number,
        collabIdFromUrlCard: {
            type: Number,
            default: null
        },
        goToNotes: {
            type: Boolean,
            default: false
        }, 
        goToComments: {
            type: Boolean,
            default: false
        },
        parentPublic: {
            type: Boolean,
            default: false
        },
        selectPublic: {
            type: Boolean,
            default: false
        },
        cardId: {
            type: Number,
            default: null
        }
    },
    data: function(){
        return {
            selectedTags: [],
            dispUrl: this.url,
            selectedBundles: [], //selections that did not exist when card pulled up for editing
            existingBundlesForEdit: [], //selections that already existed when card pulled up for editing
            toRemove: [], //selections that existed but should be removed because they were unchecked
            currCardId: this.cardsIndex != undefined ? this.$root.app.cards[this.cardsIndex].id : null,
            note: '',
            privNote: '',
            site: '',
            sure: false,
            showUrl: false,
            newTagsArr: [],
            shareId: null,
            imported: 0,
            origId: null,
            standAloneImport: null,
            bundleSearchTerm: '',
            showNewModal: false,
            callback: undefined,
            collabId: null,
            sub: true,
            pvPlaceholder: true,
            pbPlaceholder: true,
            showPrivate: false,
            borderRadius: this.$route.path == '/extension' ? 0 : '15px',
            mHeight: this.$route.path == '/extension' ? '100vh' : '90vh',
            myCard: true,
            thisRef: this,
            staticExisting: [],
            tabView: 1,
            newModalHideTree: false,
            dupAlert:false,
            dupRes: [],
            responseCheck: false,
            showCheckMark: false,
            adSure: false,
            adCreated: false,
            k0: '',
            k1: '',
            k2:'',
            k3: '',
            k4: '',
            showKeywords: false,
            waitAlert: false,
            az: az,
            contributor: '',
            showChromeTabsModal: false,
            chromeBundleName: 'Chrome Tabs',
            tabsArray: [],
            checkedTabs: [],
            showCORSAlert: false,
  
            
        }
    },
    beforeDestroy: function(){
        var self = this;
        AZEventBus.$off('onTreeNodeClicked')

        
    },
    mounted: function(){
       

        var self = this;

        if(this.goToNotes){
            this.tabView = 3;
        }

        if(this.goToComments){
            this.tabView = 2;
        }

       /*  var myCard = true

        if(!this.callApi){
            if(this.$root.app.userAttrs.sub != this.$refs.lp.card.id_cog){
                myCard = false
            }
        } */

        setTimeout(function(){
            document.addEventListener('keyup', self.escapeIt)
        }, 10)
        
        
        let ind = ''

        this.staticExisting = this.existingBundlesForEdit
        this.staticExisting.sort((a,b) => {
            return a - b;
        })

        var ti = document.getElementsByClassName('typeahead-badges')[0].prepend(document.getElementById('clearTagsAuto'))

        
        
        AZEventBus.$on('onTreeNodeClicked', this.onTreeNodeClickedHandler);
        AZEventBus.$on('imgCORSissue', this.openCORSAlert);



        if(this.note != '')
             this.pbPlaceholder = false

        if(this.privNote != ''){
            this.pvPlaceholder = false
        }

        if(this.copyCard){
          AZEventBus.$emit('onTreeNodeClicked', {id: this.bundleId, selected: true})
        }

        if(!this.callApi){
            if(this.cardsIndex && this.$root.app.cards[this.cardsIndex].myCard == false){
                this.myCard = false;
            }
        }

    },

   

    beforeDestroy: function(){
        AZEventBus.$off('onTreeNodeClicked', this.onTreeNodeClickedHandler);
        AZEventBus.$off('imgCORSissue', this.openCORSAlert);

    },

    methods: {
        startDelete: function(){
            if(!this.myCard){
                this.$root.app.showModalOK({message: 'You may not delete a card contributed by someone else.'})
                return
            }
            if(this.caller.callSearch) //called from search component
                this.$root.app.showModalOK({message: 'This will delete this miimu from all bundles, proceed?', callBack: this.caller.doDel, payload: {id: this.cardId}})
            else  
                this.$root.app.doShowModal('modalDeleteCard', {id: this.caller.id, callBack: this.caller.doDel})


        },
        openCORSAlert: function(){
            var self = this;
            setTimeout(function(){
                 self.showCORSAlert = true
            },1)
            document.getElementById('editWindowContent').classList.add('opaque')
            document.getElementById('editWindowContent').classList.add('pointerEventsOff')
        },

        closeCORS: function(){
            var self = this;
            //document.getElementById('editWindowContent').classList.remove('bgBlur')
            setTimeout(function(){
                 self.showCORSAlert = false
            },1)
            document.getElementById('editWindowContent').classList.remove('opaque')
            document.getElementById('editWindowContent').classList.remove('pointerEventsOff')
        },

      

        onTreeNodeClickedHandler: function(msg){
            let tr = this.existingBundlesForEdit.find(e => {
                return e == msg.id
            })

            if(!tr){ //new selection
                if(msg.selected){
                    this.selectedBundles.push(msg.id);
                } else {
                    ind = this.selectedBundles.findIndex(e => {
                        return e == msg.id
                    })
                    this.selectedBundles.splice(ind, 1)
                }
            } else { //selection existed when card pulled up for editing

                if(msg.selected){
                    ind = this.toRemove.findIndex(e => {
                        return e == msg.id
                    })
                    this.toRemove.splice(ind, 1)
                } else {
                    this.toRemove.push(msg.id);
                }
            }

            this.newModalHideTree = false
        },

        tester: function(ev){
            var a = document.getElementsByClassName('tags-input')
            a[0].firstChild.focus()
            this.$refs.taginput.ignoreSearchResults()
        },

        beforeTag: function(tag){
            let arr = tag.split(" ")
            if(arr.length > 0){
                this.$root.app.showModalOK({message: "Tags may not contain spaces. Use an underscore, '_' instead."})
                return false
            }
            return true
        },

        saveFromSharer: function(){
            this.saveCard()
        },

        saveIntermediary: async  function(){
            this.saveCard()
            var self = this

            return new Promise ((resolve, reject) => {
                var i = setInterval(
                    function(){
                        if(self.responseCheck){
                            clearInterval(i)
                            resolve()
                        } 
                    }, 100
                )
            })            
        },

        saveCardFromApp: async function(){
            await this.saveIntermediary()
            if(this.dupAlert){
                window.webkit.messageHandlers.myMessageName.postMessage('in account')
            } else {
                window.webkit.messageHandlers.myMessageName.postMessage('ok')
            }
        },

        pbPlaceholderFocus: function(){
           var self = this;
          /*  setTimeout(function(){
             self.$refs.note.setAttribute('contenteditable', 'true')
           }, 5) */
           this.pbPlaceholder = false
        },

        tabSwitcher: function(val){
            this.tabView = val
            if(this.$root.app.$tours['myTour'].isRunning && (this.$root.app.$tours['myTour'].step.target == '#v-step-5' || this.$root.app.$tours['myTour'].step.target == '#v-step-6'))
                this.$parent.$parent.nextTourStep()
        },

        openPrivNotes: function(){
            this.showPrivate = !this.showPrivate
            this.checkPlaceholders()
        },

       

        pvPlaceholderFocus: function(){
           this.pvPlaceholder = false
        },

        checkPlaceholders: function(){
           /*  if(this.$refs.note.textContent == '') 
                this.pbPlaceholder = true 
            else this.pbPlaceholder = false */
            //this.$refs.note.setAttribute('contenteditable', 'false')
            if(this.myCard){
                if(this.$refs.privNote.innerText == '') 
                    this.pvPlaceholder = true 
                else this.pvPlaceholder = false
            }

            if(this.myCard){
                if(this.$refs.note.innerText == '') 
                    this.pbPlaceholder = true 
                else this.pbPlaceholder = false
            }
        },
        
        updateUI: function(nORe, item, newParents, newTagsObj, removeTagEntryIds, toMakeDirty, remDirtyIds){

            var self = this;

            if(this.copyCard || this.cardPack != undefined){
                item.myCard = true
                item.parents = []
            }

         
            var inbox = this.$root.app.bundles.find(e => {
                return e.isInbox == true
            })

            var inboxIndex = this.$root.app.bundles.findIndex(e => {
                return e.isInbox == true
            })

            

            

            if(!this.callApi && !this.copyCard){  

                //since there are bundles selected, if card is in inbox, remove it
                
                let inboxId = inbox.id
                if(this.selectedBundles.length > 0 && this.$refs.lp.card.parents && this.$refs.lp.card.parents[0].id == inboxId) 
                    this.toRemove.push(inboxId)

                function red(arr){
                    let res = arr.filter((c, index) => {
                        return arr.indexOf(c) === index;
                    });

                    return res
                }


                this.toRemove = red(this.toRemove)

                //remove from unchecked bundles
                for(let e=0; e < this.toRemove.length; e++){
                    
                    //find bundle and remove this cardId from items
                    let bundleId = this.toRemove[e];
 
                    let bund = this.$root.app.bundles.find(e => {
                        return e.id == bundleId
                    })

                    let ind = bund.items.findIndex((x) => {
                        return x.id == this.$refs.lp.card.id
                    })
                    bund.items.splice(ind, 1);

                    //find card and remove bundle from parents
                    let ind2 = this.$root.app.cards[this.$refs.lp.cardsIndex].parents.findIndex((x) => {
                        return x.id == bundleId
                    })
                    if(ind2 > -1){
                        this.$root.app.cards[this.$refs.lp.cardsIndex].parents.splice(ind2, 1);
                    }

                    //remove from existingBundlesForEdit
                    let ind3 = this.existingBundlesForEdit.findIndex((x) => {
                        return x == bundleId
                    })
                    this.existingBundlesForEdit.splice(ind3, 1);

                }
            }

            
                       
        
             
            //Save tree selections into bundles (only new ones, if prev selected it is NOT handled here)
            if(newParents != 'ok'){ //means there are new parents

                for(let i = 0; i < newParents.length; i++){
                    let bundleId = newParents[i].id_BUNDLES;
                    let bund = this.$root.app.bundles.find(e => {
                        return e.id == bundleId
                    })


                    let ci = this.$root.app.cards.length 

                    if(!this.callApi && !this.copyCard && this.cardPack == undefined){
                        item.id = this.$refs.lp.card.id
                        ci = this.$refs.lp.cardsIndex
                    }  else {
                        item.id_cog = this.$root.app.userAttrs.sub
                    }

                   
                    
                    item.parents.push({id: bundleId, p: newParents[i].p, entryId: newParents[i].id});
                    bund.items.push({cardsIndex: ci , id: item.id, p: newParents[i].p, entryId: newParents[i].id});
                    bund.items.sort(function(a,b){ return a.p - b.p});

                  
                }

              
    
            } else if (this.selectedBundles.length == 0 && this.existingBundlesForEdit.length == 0) {

                //No selections on tree means card should go to inbox:
               
                let inboxPos
                if(this.$root.app.bundles[0].items.length > 0){
                    inboxPos = this.$root.app.bundles[0].items[0].p / 2
                } else {
                    inboxPos = 16000;
                }

                let ci = this.$root.app.cards.length

                if(!this.callApi && !this.copyCard){ //only if adding new card
                    item.id = this.$refs.lp.card.id
                    ci = this.$refs.lp.cardsIndex
                } else {
                    item.id_cog = this.$root.app.userAttrs.sub
                }

                item.parents.push({id: inbox.id, p: inboxPos, entryId: newParents[i].id})  
                this.$root.app.bundles[inboxIndex].items.unshift({id: item.id, pos: inboxPos, cardsIndex: ci, entryId: newParents[i].id});

            }

            var newTags = []
            if(newTagsObj.length){
                newTags = JSON.parse(newTagsObj)
            } else {
                newTags = []
            }
            
            if(newTagsObj.length && nORe == 'new'){
                item.tags = newTags
            } else if(nORe == 'edit'){
                let currTags = item.tags
                //remove removeTagEntryIds from currTags
                let remaining = currTags.filter(e => {
                    return !removeTagEntryIds.includes(e.entryId)
                })
                //combine currTags with newTags
                item.tags = remaining.concat(newTags)

                //assign to item.tags
            }

            var dirtyArr = toMakeDirty || [];

            if(dirtyArr.length > 0){
                dirtyArr.forEach(e => {

                    let bund = self.$root.app.bundles.find(n => {
                        return n.id == e
                    })

                    if(bund.beenShared)
                        bund.dirt += 1 
                        self.$root.app.checkForRootDirtAlert(e)
                })
            }

            var remDirties = remDirtyIds || []

            if(remDirties.length){
                remDirties.forEach(e => {
                    let bund = self.$root.app.bundles.find(n => {
                        return n.id == e
                    })

                    if(bund.beenShared && bund.dirt > 0){
                        bund.dirt -=1;
                        self.$root.app.checkForRootDirtAlert(e)
                    }
                })
            }

            if(this.callApi || this.copyCard || this.cardPack){ //only do this if adding new card
                this.$root.app.cards.push(item);
            } else {
              

               this.$root.app.cards[this.cardsIndex].title = item.title
               this.$root.app.cards[this.cardsIndex].description = item.description
               this.$root.app.cards[this.cardsIndex].note = item.note
               this.$root.app.cards[this.cardsIndex].privNote = item.privNote
               this.$root.app.cards[this.cardsIndex].tags = item.tags
               this.$root.app.cards[this.cardsIndex].parents = item.parents

               this.$root.app.cards[this.cardsIndex].img = item.img
            


               //this.caller.forceUpdate()

           
            }
           
            this.$emit('close')
        },

        makeACopy: function(){
            this.$root.app.copyCardCallback({url: '', cardsIndex: this.cardsIndex, callApi: false, caller: this, bundleId: 0, before: null, after: null, fromBundleId: this.bundleId})
        },

        removeSaveListener: function(){
            var self = this
            document.removeEventListener('keyup', self.escapeIt);
        },

        saveCard: function(bypassDupAlert){
           
            document.removeEventListener('keyup', this.escapeIt);

          

            if(this.$root.app.$tours['myTour'].isRunning && !this.$root.app.$tours['myTour'].isLast ){
                return
            }

            if(this.$root.app.$tours['myTour'].isLast)
                this.$root.app.endTour('myTour')

            
            

            if(this.newModalHideTree){
                return
            }

            window.scrollTo(0,0)
            

            /* if(az.noSlash(this.$route.path) != '/extension'){
                document.getElementById('saveIcon').classList.add('pointerEventsOff')
            } */
            

            if(!this.$root.app.bundles || this.$root.app.bundles.legnth == 0){
               this.waitAlert = true
                return
            }


            var bpsDup
            if(bypassDupAlert == true){
                bpsDup = true
            } else {
                bpsDup = false
            }

            this.dupAlert = false;

            if(this.$refs.lp.$refs.title.textContent == 'Enter title'){
                this.$refs.lp.titleEmpty = true
                return
            }

            if(this.$refs.lp.cropper){
                this.$refs.lp.cropperClip()
            }

            let item = {
                id: ++this.$root.app.tempId, //this id will be insert id coming back from backend
                parents: this.$root.app.cards[this.cardsIndex] ? this.$root.app.cards[this.cardsIndex].parents : [],  
                type: 'url', //hc
                site: this.$refs.lp.response.site, 
                title: this.$refs.lp.$refs.title.textContent,
                description: this.$refs.lp.$refs.description.textContent,
                url: this.$refs.lp.url,
                img: this.$refs.lp.img,
                note: this.$refs.note.innerText,
                privNote: this.$refs.privNote ? this.$refs.privNote.innerText : '',
                tags: this.selectedTags, //tbd
            }

          

            //Make list of bundles to add with their positions
                var addBundles = [];
                //var rePosition = false
                for(let i = 0; i < this.selectedBundles.length; i++){
                    let bundleId = this.selectedBundles[i];
                    let bund = this.$root.app.bundles.find(e => {
                        return e.id == bundleId
                    })

                    let beenShared = bund.beenShared

                 
                    addBundles.push({id_CARDS: this.callApi == false ? this.$refs.lp.card.id : null, id_BUNDLES: bundleId, beenShared: beenShared, importAcl: bund.importAcl,  collabId: bund.collabId})
                }

                //if no selections make sure it's in inbox
                var bund = this.$root.app.bundles.find(e => {
                                return e.isInbox == true
                            })

                var bundId = bund.id

                if(this.selectedBundles.length == 0 ){

                    let self = this
                    //rePosition = false

                    //make sure no bundles are selected
                    let diff = this.existingBundlesForEdit.filter(
                        function(i) {
                            i = parseInt(i)
                            return self.toRemove.indexOf(i) < 0;
                        }
                    );
                
                    if(diff.length == 0){

                        let found = -1

                        if(this.callApi == false){
                            found = bund.items.findIndex(e => {
                                return e.id == this.$refs.lp.card.id
                            })
                        }

                        if(found == -1){

                           /*  let pos2
                            let nextPos = null
                            if(bund.items.length){
                                pos2 = bund.items[0].p / 2
                                if(pos2 < this.$root.app.posThreshold){
                                    pos2 = 16000
                                    rePosition = true
                                    nextPos = bund.items[0].p
                                }
                            } else {
                                pos2 = 16000;
                                nextPos = null
                            } */

                            addBundles.push({id_CARDS: this.callApi == false ? this.$refs.lp.card.id : null, id_BUNDLES: bundId,  beenShared: bund.beenShared, importAcl: null, collabId: null})
                        }

                    }
                }
      

            //Deal with textChanges               
                let textChanges = {};
                if(this.$refs.lp.response.title != this.$refs.lp.$refs.title.textContent){
                    textChanges.title = this.$refs.lp.$refs.title.textContent;
                }

                if(this.$refs.lp.response.description != this.$refs.lp.$refs.description.textContent){
                    textChanges.description = this.$refs.lp.$refs.description.textContent;
                }

                if(this.note != this.$refs.note.innerText){
                    textChanges.note = this.$refs.note.innerText;
                }
                if(this.privNote){
                    if(this.privNote != this.$refs.privNote.innerText){
                        textChanges.privNote = this.$refs.privNote.innerText;
                    }
                }

            function checkObjProps(object, key) {
                return object[Object.keys(object)
                    .find(k => k.toLowerCase() === key.toLowerCase())
                ];
            }


            let addTags

            var imgFile = 'noChange'

            if(this.callApi || this.cardPack != undefined || this.copyCard){
                //NEW CARD
                this.responseCheck = false
                var self = this

                function w2(data){

                    if(data == 'miimu limit exceeded'){
                        if(!self.$root.app.inApp)
                            self.$root.app.doShowModal('ModalUpg', {limit: 'm'})
                        else
                            self.$root.app.doShowModal('ModalOK', {message: `Congratulations! You've created a ton of miimus! To create more, please visit your account settings from any web browser.`})

                        return
                    }
                    
                    self.responseCheck = true
                    if(data.m == 'Already in Account'){
                        self.dupAlert = true;
                        window.scrollTo(0,0)
                        var arr = []

                       

                        
                        data.q.forEach(e => {
                          
                            var objs = []
                            var pn = e.parentNames.split('|')
                            var p  = e.parents.split(',')
                            var rn  = e.roots.split('|')
                            var r  = e.rootIds.split(',')

                        
                            r.forEach((i, ind) => {
                                var o = {parentId: '', parentName:'', rootId:'', rootName:''}
                                o.parentId = parseInt(p[ind]);
                                o.parentName = pn[ind]; 
                                o.rootId = parseInt(r[ind]);
                                o.rootName = rn[ind];
                                objs.push(o)
                            })
                        
                            arr.push(objs)

                        })

                       

                        self.dupRes = arr

                       

                        return

                    }    
                    
                    if(az.noSlash(self.$route.path) == '/extension' && self.$root.app.inApp){
                    
                        self.showCheckMark = true
                        setTimeout(function(){ 
                            window.webkit.messageHandlers.myMessageName.postMessage("close")
                        }, 500)
                        
                        return
                    }
            
                    if(az.noSlash(self.$route.path) == '/extension' && !self.dupAlert) {
                        self.showCheckMark = true
                        setTimeout(function(){
                            top.window.postMessage({data: {message: 'closeIt'}}, "*");
                        }, 500)
                        
                        return
                    }

                     

                        
                        az.addRemSpinner(false, 'id', 'saveCardButt');
                        az.addRemSpinner(false, 'id', 'saveCardButt2');
                        az.addRemSpinner(false, 'id', 'saving');
                        if(self.callApi || self.copyCard || self.cardPack != undefined){
                            if(data.response.length){

                                let bundlesArr = []
                                data.response.forEach(e => {
                                    //Find bundles that are aliased and use their local id instead of the original DB id.
                                    let aliasB = self.$root.app.bundles.find(i => {
                                        return i.aliasTgtId == e.id_BUNDLES
                                    })

                                    if(!aliasB){
                                        bundlesArr.push(e.id_BUNDLES)
                                    } else {
                                        bundlesArr.push(aliasB.id)
                                    }
                                    
                                })

                            

                                item.id = data.response[0].id_CARDS;
                                item.myCard = true
                                if(self.copyCard){
                                    item.url = self.$refs.lp.card.url
                                    
                                }
                                
                            
                                self.updateUI('new', item, data.response,  data.newTagsObj, null,  bundlesArr, null)

                                if(data.repos){
                                    self.$root.app.rePositioner(data.repos)
                                }
                                
                               
                            } else {
                                self.updateUI('new', item, null,  data.newTagsObj, null, null, null)

                               
                            }

                            if(self.$root.app.inApp && az.noSlash(self.$route.path) == '/extension')
                                window.webkit.messageHandlers.myMessageName.postMessage('saveCard')

                           
                    

                            
                        } else {
                            document.removeEventListener('keyup', self.escapeIt);
                            self.$emit('close')
                        }

                       

                }

                function n2(e){
                    az.addRemSpinner(false, 'id', 'saveCardButt');
                    az.addRemSpinner(false, 'id', 'saveCardButt2');
                    az.addRemSpinner(false, 'id', 'saving');
                    self.$root.app.showModalOK({message: 'There was an error processing your request. Please try again or contact support.'})
                }
                
                let newItem = {
                    site: this.$refs.lp.response.site, 
                    title: this.$refs.lp.$refs.title.textContent,
                    description: this.$refs.lp.$refs.description.textContent,
                    url: this.copyCard ? this.$refs.lp.card.url : this.$refs.lp.url,
                    img: this.$refs.lp.img,
                    note: this.$refs.note.innerText,
                    shareId: this.shareId, 
                    imported: false, 
                    origId: this.origId, 
                    
                    standAloneImport: this.standAloneImport
                }

                if(this.$refs.privNote && this.$refs.privNote.innerText){
                    newItem.privNote = this.$refs.privNote.innerText
                }
              

                if(this.cardPack != undefined){
                    newItem.imported = true;
                }

                //Make list of tags to add 
                addTags = []
                this.newTagsArr.forEach(e => {
                    let i = this.selectedTags.findIndex(a => {
                        return a.tag == e
                    })

                    if(i == -1){
                       addTags.push(e)

                       if(checkObjProps(self.$root.app.tagUniverse, e) != undefined){
                           self.$root.app.tagUniverse[e] = e;
                       }
                        
                    }
                })               

                az.addRemSpinner(true, 'id', 'saveCardButt');
                az.addRemSpinner(true, 'id', 'saveCardButt2');
                az.addRemSpinner(true, 'id', 'saving');

                if(this.$refs.lp.imgChanged)
                    imgFile = this.$refs.lp.currImg

                var checkLimits = this.$root.app.checkLimits
        
                this.$root.app.apiClient.post('subs/data/card', {checkLimits: checkLimits, item: newItem, changes: textChanges, addBundles: addBundles, addTags: addTags, imgFile: imgFile, bypassDupAlert: bpsDup, inExt: az.noSlash(this.$route.path) == '/extension'}, w2, n2);

            } else {
                //EDIT CARD
                item.id = this.$refs.lp.card.id
                var self = this;

                if(this.selectedBundles.length > 0) 
                    this.toRemove.push(bundId)

                //Make list of entryIds to remove crom CARDS_PARENTS table
                let removeEntryIds = []
                for(let i=0; i < this.toRemove.length; i++){

                    //find curCarrId in toRemove bundle's items
                    let bund2 = this.$root.app.bundles.find((e) => {
                        return e.id == this.toRemove[i]
                    });


                    let ei = bund2.items.find((x) => {
                        return x.id == this.$refs.lp.card.id
                    })

                    if(ei != undefined){
                        let fromBeenSharedId = bund2.beenShared ? bund2.id : 0
                        removeEntryIds.push({ei: ei.entryId, fromBeenShared: fromBeenSharedId})
                    }
                    
                  
                }

                //Make list of entryIds to remove from TAGS_CARDS table
                let removeTagEntryIds = []
                this.selectedTags.forEach(e => {
                    let i = this.newTagsArr.findIndex(a => {
                        return a == e.tag
                    })

                    if (i == -1)
                        removeTagEntryIds.push(e.entryId)
                })
                
                //Make list of tags to add 
                addTags = []
                this.newTagsArr.forEach(e => {
                    let i = this.selectedTags.findIndex(a => {
                        return a.tag == e
                    })

                    if(i == -1){
                        addTags.push(e)

                        if(checkObjProps(self.$root.app.tagUniverse, e) == undefined){
                           self.$root.app.tagUniverse[e] = e;
                        }
                    }
                })


                /////API CALL

                var self = this
                function w(data){
                    az.addRemSpinner(false, 'id', 'saveCardButt');
                    az.addRemSpinner(true, 'id', 'saveCardButt2');
                    az.addRemSpinner(false, 'id', 'saving');
                    document.removeEventListener('keyup', self.escapeIt);

                    if(data.response == 'stale data'){
                        self.$root.app.showModalOK({message: 'E3: Your data is not up to date. Please refresh and try again. We are working on a better way to sync data within collab bundles. Stay tuned.'})
                        return
                    }

            
                    if(data.response.length){
                        self.updateUI('edit', item, data.response, data.newTagsObj, removeTagEntryIds, data.toMakeDirty, data.remDirtyIds)

                        if(data.repos){
                            self.$root.app.rePositioner(data.repos)
                        }
                    } else {
                        self.updateUI('edit', item, null, data.newTagsObj, removeTagEntryIds, data.toMakeDirty, data.remDirtyIds)
                    }
                    
                }

                function n(e){
                     az.addRemSpinner(false, 'id', 'saveCardButt');
                     az.addRemSpinner(false, 'id', 'saveCardButt2');
                     az.addRemSpinner(false, 'id', 'saving');
                     self.$root.app.showModalOK({message: 'There was an error processing your request. Please try again or contact support.'})
                }
                
            
                if(this.$refs.lp.imgChanged)
                    imgFile = this.$refs.lp.currImg

                if(this.$refs.lp.newImgFromSite)
                    textChanges.img = this.$refs.lp.img

                az.addRemSpinner(true, 'id', 'saveCardButt');
                az.addRemSpinner(true, 'id', 'saveCardButt2');
                az.addRemSpinner(true, 'id', 'saving');

                
                this.$root.app.apiClient.put('subs/data/card', {cardId: this.$refs.lp.card.id, changes: textChanges, removeEntryIds: removeEntryIds, addBundles: addBundles, removeTagEntryIds: removeTagEntryIds, addTags: addTags, imgFile: imgFile, staticExisting: this.staticExisting, doCollabCheck: true}, w, n);

            }

        },
        
        escapeIt: function escapeIt(evt){   
            let self = this;
            if (evt.keyCode === 27) {
                self.cancel();
            } else if(evt.key === 'Enter' && document.activeElement.type != 'text' && !this.showNewModal && !document.activeElement.attributes.getNamedItem('contenteditable')){
                self.saveCard()
            }
            
        },


        cancel: function(evt){
            document.removeEventListener('keyup', this.escapeIt);
            AZEventBus.$off('onTreeNodeClicked')
            window.scrollTo(0,0)
            if(this.$route.path == '/extension') 
               top.window.postMessage({data: {message: 'closeIt'}}, "*");

            if(this.$root.app.inApp && az.noSlash(this.$route.path) == '/extension'){
                window.webkit.messageHandlers.myMessageName.postMessage("close")
            }

            this.$emit('close')

            
        },

        closeChromeTabsModal: function(){
            this.showChromeTabsModal = false
        },

        openChromeTabsModal: function(){
            this.tabsImport()
            this.showChromeTabsModal = true
        },

        deleteCard: function(){

            var self = this;

            let cardParents = this.$root.app.cards[this.cardsIndex].parents
            
            let tgtParent = cardParents.find((e) => {
                return e.id == this.bundleId
            })

            let entryId = tgtParent.entryId

            function w(data){
                az.addRemSpinner(false, 'id', 'yesButt');
                if(data.response == 'ok'){

                    var index = self.$root.app.bundles.findIndex(e => {
                        return e.id == self.bundleId
                    })

                    var i = self.$root.app.bundles[index].items.findIndex(e => {
                        return e.id == self.currCardId
                    })
                   
                    //remove from bundle.items
                    self.$root.app.bundles[index].items.splice(i, 1)

                    //remove from cards.parents
                    let theId = self.$root.app.bundles[index].id
                    let pars = self.$root.app.cards[self.cardsIndex].parents
                    let ind = pars.findIndex(e => {
                        return e.id == theId
                    })
                    pars.splice(ind, 1)
                    
                }
                self.$emit('close')
            }

            function n(){
                az.addRemSpinner(false, 'id', 'yesButt');
                self.$emit('close')
                self.$root.app.showModalOK({message: 'There was an error processing your request, please try again or contact support.'})
            }

            az.addRemSpinner(true, 'id', 'yesButt');
            this.$root.app.apiClient.delete('subs/data/card', {entryId: entryId}, w, n);
            
        },
        bundleFilter: function(){

            if(this.bundleSearchTerm == ''){
                AZEventBus.$emit('collapseTrees', null)
                AZEventBus.$emit('treesCheckIfSelected', null)
                return
            }

            var filteredBundles = []
            
            var filtered = this.$root.app.bundles.filter(e => {
                /* return e.listName.toLowerCase() == this.bundleSearchTerm.toLowerCase() */

                let i = e.listName.toLowerCase().indexOf(this.bundleSearchTerm.toLowerCase().trim())

                if(i != -1) 
                    return true
                else
                    return false
            })

            filtered.forEach(e => {
                filteredBundles.push(e.id)
            })

           

            AZEventBus.$emit('collapseTrees', null)
            AZEventBus.$emit('filteredBundles', filteredBundles)

            if(filteredBundles.length){
                setTimeout(function(){
                    var el = document.getElementById('tr' + filteredBundles[0])
                    el.scrollIntoView({behavior: 'instant', inline: 'start'})
                    document.getElementById('treeView').scrollLeft = 0
                },5)

                setTimeout(function(){
                    document.getElementById('editWindowTreeContainer').scrollTo(0,0)
                },10)
            }
          
           

        },
        addSub: function(callBack, collabId, fromTree){
            //document.getElementById('editWindowContent').classList.add('bgBlur')
            this.newModalHideTree = fromTree

            document.getElementById('editWindowContent').classList.add('opaque')
            document.getElementById('editWindowContent').classList.add('pointerEventsOff')
            this.callback = callBack
            this.collabId = collabId
            this.sub = true;
            this.showNewModal = true

            if(this.$root.app.$tours.myTour.isRunning){
                this.$parent.$parent.nextTourStep()
            }
        },
        closeNewSub: function(){
            var self = this;
            //document.getElementById('editWindowContent').classList.remove('bgBlur')
            setTimeout(function(){
                 self.showNewModal = false
            },1)
            document.getElementById('editWindowContent').classList.remove('opaque')
            document.getElementById('editWindowContent').classList.remove('pointerEventsOff')
            this.callback = undefined
            this.collabId = null
            
           
        },

        addRootBundle: function(){
            var self = this;
            
            //document.getElementById('editWindowContent').classList.add('bgBlur')
            document.getElementById('editWindowContent').classList.add('opaque')
            document.getElementById('editWindowContent').classList.add('pointerEventsOff')
            this.callback = this.saveRootBundle
            this.sub = false;
            this.showNewModal = true
            setTimeout(function(){
                self.$parent.$parent.nextTourStep()
            }, 10)
            
         
        },

        /* openComments: function(){
            var self = this
            var tempCollabId
            var thB = this.$root.app.bundles.find(n => {
                        return n.id == self.bundleId
                    })
            if(thB){
                tempCollabId = thB.collabId
            }
            this.$root.app.openComments({id: this.$refs.lp.card.id, title: this.$refs.lp.response.title, img: this.$refs.lp.response.images[0]}, this.bundleId, tempCollabId)
            this.$emit('close')
        }, */


        saveRootBundle: function(bundleName, collabId, toInclude, isCollab){

            var self = this;

            function w(data){

                if(data == 'bundle limit exceeded'){
                    self.$root.app.doShowModal('ModalUpg', {limit: 'b'})
                    return
                }

                let bId = data.response
                let newBranch = [bId]
                let b = bFactory(bId, true, bundleName, newBranch)

                if(data.collabId)
                    b.collabId = collabId || data.collabId
                b.id_cog = self.$root.app.userAttrs.sub

                self.$root.app.bundles.push(b);
                self.$root.app.treeNoInbox.splice(0, 0, b)

                self.$nextTick(() => {
                    let msg = {};
                    msg.id = bId
                    msg.actualId = bId
                    msg.selected = true
                    AZEventBus.$emit('onTreeNodeClicked', msg)
                    self.$refs.cBoxes[0].isSelected = true
                })
               
              
            }

            function n(){
                self.$root.app.showModalOK({message: 'There was an error processing your request. Please try again or contact support.'})
            }

            //TODO implement proximity check
            let p
            if(self.$root.app.treeNoInbox[0])
                p =  self.$root.app.treeNoInbox[0].p / 2
            else
                p = 16000

            var checkLimits = this.$root.app.checkLimits
            self.$root.app.apiClient.post('subs/data/bundle', {checkLimits: checkLimits, name: bundleName, isRoot: true, targetBundle: 'root', p: p, isCollab: isCollab, collabId: null, toInclude: []}, w, n);
        },

        createAdSure: function(){
            this.adSure = true
        },

        adSureFalse: function(){
            var self = this
            setTimeout(function(){
                 self.adSure = false
            }, 4)
        },

        createAd: function(){

            var self = this

            var str = ''

            for(var x=0; x < 5; x++){
                if(this['k' + x] != ''){
                    str += `"${this['k' + x]}",`
                }
            }
            //str =  str.slice(-1, 1)
            str = str.slice(0, -1)

            function w(d){
                self.adCreated = true
                self.showKeywords = false
            }

            function n(){

            }
            this.$root.app.apiClient.post('subs/data/createad', {site:  this.$refs.lp.response.site, url: this.dispUrl, title: this.$refs.lp.$refs.title.textContent,
                 description: this.$refs.lp.$refs.description.textContent, img: this.$refs.lp.img, keywords: str}, w, n)
           
           
        },


        tabsImport: function(){
            az.addRemSpinner(true, 'id', 'chromeTabsButt')
            top.window.postMessage({data: {message: 'importTabs'}}, "*");

        },

        showTabs: function(tabs){
            az.addRemSpinner(false, 'id', 'chromeTabsButt')
            this.tabsArray = tabs
            this.checkedTabs = tabs
        },

        sendTabsToBackend: function(){
            if(this.checkedTabs.length == 0){

                return
            }

            az.addRemSpinner(true, 'id', 'chromeTabsButt')
            this.$root.app.tabsToMiimus(this.checkedTabs)
        }
    },
    computed: {
        applyClass: function(){
            return this.$refs.commentsComp.length
        },
        computedItem: function(){
            return  {id: this.currCardId}
        },
        source: function(){
            return  this.$root.app.sourceIcon(this.site)
        },
        initials: function(){
            var val = this.$refs.lp.card.id_cog
         
            for(var i=0; i < this.$root.app.groupMembers.length; i++){
                if(this.$root.app.groupMembers[i].id_customer == val){
                    this.contributor = this.$root.app.groupMembers[i].fName + ' ' + this.$root.app.groupMembers[i].lName
                    return this.$root.app.groupMembers[i].fName.charAt(0).toUpperCase() + this.$root.app.groupMembers[i].lName.charAt(0).toUpperCase()
                }
            }
            return ''
        },
        
        processedTags: {
            get: function(){
                var arr = []
                if(this.selectedTags){
                    this.selectedTags.forEach(e => {
                        arr.push(e.tag)
                    })
                }

                return arr
            },

            set: function(newVal){
                this.newTagsArr = newVal
            }

            
        },
        mainTitle: function(){
            if(this.copyCard){
                return ' COPY MIIMU'
            } else if(this.callApi){
                return ' NEW MIIMU'
            } else {
                return 'DETAILS'
            }
        },

        bundlesLoaded: function(){
            return this.$root.app.bundles.length > 0
        },

        filteredTreeNoInbox: function(){

            var self = this

            if(!this.copyCard && this.myCard){
                return this.$root.app.treeNoInbox

            } else if(!this.myCard && !this.copyCard){
            

                    //recurse through tree to remove all but origin collab bundle from tree
                    var theBund = this.$root.app.bundles.find(n => {
                        return n.id == self.bundleId
                    })


                    //if(theBund > -1){
            
                        var collabId = theBund.collabId
                        

                        function rem(ch){
                            
                            ch.forEach((e, i) => {                    
                                
                                if(e){
                                    if(e.collabId != collabId){
                                        ch[i].hideMe = true
                                    }

                                    if(e.children.length > 0){
                                        rem(e.children)
                                    }
                                }
                            })
                            
                            return ch
                        }

                        let arr2 = JSON.parse(JSON.stringify(this.$root.app.treeNoInbox));
                        return rem(arr2)
                    //}
                
                    return this.$root.app.treeNoInbox
            } else {
     
                //recurse through tree to remove origin collab bundle from tree
                function rec(ch){
                    
                    ch.forEach((e, i) => {                    
                        if(e){
                            if(e.id == self.fromBundleId){
                                //ch.splice(i,1)
                                ch[i].hideMe = true
                            }

                            if(e.children.length > 0){
                                rec(e.children)
                            }
                        }
                    })
                    
                    return ch
                }

                function rec2(ch){
                    
                    if(self.bundleId != 0){
                      
                        ch.forEach((e, i) => {                    
                            if(e){
                                if(e.id == self.bundleId){
                                    ch[i].selectedFromCopyCard = true
                                } 

                                if(e.children.length > 0){
                                    rec2(e.children)
                                }
                            }
                        })
                    }
                    
                    return ch

                }
              
                let arr = JSON.parse(JSON.stringify(this.$root.app.treeNoInbox));
                return rec2(rec(arr))

            }
        }
        
    }
}
</script>

<style scoped>
    #xButt{
        background-color: transparent !important;
        position: absolute;
        font-size: 2rem !important;
        right: 20px;
    }

    .delete::after{
        width: 1px;
        height: 100%
    }
     .delete::before{
        height: 1px;
        width: 100%
    }
</style>
